import React from "react";

import { classnames } from "@culturehq/components";

class AccessibleFocusOutlineElement extends React.Component {
  state = {
    enableOutline: false
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeydown);
    window.addEventListener("click", this.handleMouseClick);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeydown);
    window.removeEventListener("click", this.handleMouseClick);
  }

  handleKeydown = event => {
    const isTabEvent = event.keyCode === 9;

    if (isTabEvent) {
      this.setState({ enableOutline: true });
    }
  }

  handleMouseClick = () => {
    this.setState({ enableOutline: false });
  }

  handleClick = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
  }

  render() {
    const { children, className, disabled, tag: Tag } = this.props;
    const { enableOutline } = this.state;

    const classes = classnames(
      className,
      { "no-outline-on-focus": !enableOutline },
      { "chq-btn-blk": disabled }
    );

    return (
      <Tag className={classes} onClick={this.handleClick} disabled={disabled}>
        {children}
      </Tag>
    );
  }
}

export default AccessibleFocusOutlineElement;
